import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useRefresh } from 'react-admin';
import { useRunRequest } from '@/hooks';
import { path } from '@/pages/AdverseAction/constants';
import { TurnResourcesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { AdverseEditDisputeProps } from '../types';

const useController = ({ toggleEditDispute }: AdverseEditDisputeProps) => {
  const { getValues, handleSubmit } = useFormContext();
  const { runRequest } = useRunRequest();
  const refresh = useRefresh();
  const { id: workerId } = useParams<{ id: string }>();

  const handleClose = () => toggleEditDispute();

  const handleSave = async () => {
    const dispute = getValues(path('adverse.dispute'));
    const comment = getValues(path('adverse.comments'));

    const response = await runRequest({
      fetchType: 'UPDATE',
      resource: TurnResourcesEnum.FcraWorkersAdverse,
      params: {
        id: workerId,
        target: TurnTargetsEnum.Dispute,
        data: { comment, dispute },
      },
      mode: 'notify',
      notify: {
        onError: { message: 'Error saving dispute' },
        onSuccess: { message: 'Dispute saved correctly' },
      },
    });

    if (response) {
      refresh();
    }

    handleClose();
  };

  return {
    handleClose,
    handleSave: handleSubmit(handleSave),
  };
};

export default useController;
